function bindPricingToggles(root) {
    (root || document).querySelectorAll('[data-pricing-toggle]').forEach((toggle) => {
        if (toggle._pricingBound) return;
        toggle._pricingBound = true;
        toggle.addEventListener('click', () => {
            const card = toggle.parentElement;
            const content = card.querySelector('[data-pricing-content]');
            const chevron = toggle.querySelector('[data-pricing-chevron]');
            const isOpen = content.style.maxHeight;

            if (isOpen) {
                content.style.maxHeight = null;
                chevron.classList.remove('rotate-180');
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
                chevron.classList.add('rotate-180');
            }
        });
    });
}

export function initPricing() {
    bindPricingToggles(document);
}

export function initClinicSelect() {
    const select = document.querySelector('[data-clinic-select]');
    if (!select) return;

    const section = document.querySelector('[data-clinic-pricing-section]');

    select.addEventListener('change', () => {
        const clinicId = select.value;

        document.querySelectorAll('[data-clinic-pricing]').forEach((el) => {
            el.classList.add('hidden');
            el.classList.remove('is-entering');
        });

        if (clinicId) {
            const target = document.querySelector('[data-clinic-pricing="' + clinicId + '"]');
            if (target) {
                target.classList.remove('hidden');
                target.getBoundingClientRect();
                target.classList.add('is-entering');
                target.addEventListener('animationend', () => target.classList.remove('is-entering'), { once: true });
                bindPricingToggles(target);
            }

            if (section && section.classList.contains('hidden')) {
                section.classList.remove('hidden');
                section.getBoundingClientRect();
                section.classList.add('is-visible');
                section.addEventListener('animationend', () => section.classList.remove('is-visible'), { once: true });
            }
        } else {
            if (section) {
                section.classList.add('hidden');
                section.classList.remove('is-visible');
            }
        }
    });
}
